/**
 * Aiká — Redireciona pro checkout com e-mail pré-preenchido
 *
 * Se a pessoa já deixou o e-mail no popup (ou em qualquer outro
 * formulário que grave na mesma chave), o clique no botão de
 * finalizar compra é interceptado e redirecionado direto pra
 * /checkout com o e-mail já preenchido via parâmetro oficial da
 * Shopify (checkout[email]).
 *
 * Importante: o carrinho em si NÃO é reconstruído nem tocado — é a
 * mesma sessão de carrinho existente, só acrescentando o e-mail na
 * URL. Isso preserva desconto aplicado, propriedades de linha (como
 * a seleção de velas dos kits) e tudo mais, sem risco de perder nada
 * na reconstrução.
 *
 * Se não houver e-mail capturado, o clique segue o fluxo normal do
 * Shopify, sem nenhuma interferência.
 */
document.addEventListener('DOMContentLoaded', () => {
  const EMAIL_KEY = 'aika_captured_email';

  document.querySelectorAll('button[name="checkout"]').forEach((button) => {
    const form = button.closest('form');
    if (!form) return;

    form.addEventListener('submit', (event) => {
      if (event.submitter !== button) return;

      const email = localStorage.getItem(EMAIL_KEY);
      if (!email) return;

      event.preventDefault();
      window.location.href = '/checkout?checkout%5Bemail%5D=' + encodeURIComponent(email);
    });
  });
});
